import _toConsumableArray from "/home/patrick/jamespatrickleduc.github.io/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/patrick/jamespatrickleduc.github.io/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/patrick/jamespatrickleduc.github.io/node_modules/@babel/runtime/helpers/esm/createClass";
import { lineLength } from '../geometry';
import { polygonHachureLines } from './scan-line-hachure';
export var DashedFiller = /*#__PURE__*/function () {
  function DashedFiller(helper) {
    _classCallCheck(this, DashedFiller);

    this.helper = helper;
  }

  _createClass(DashedFiller, [{
    key: "fillPolygon",
    value: function fillPolygon(points, o) {
      var lines = polygonHachureLines(points, o);
      return {
        type: 'fillSketch',
        ops: this.dashedLine(lines, o)
      };
    }
  }, {
    key: "dashedLine",
    value: function dashedLine(lines, o) {
      var _this = this;

      var offset = o.dashOffset < 0 ? o.hachureGap < 0 ? o.strokeWidth * 4 : o.hachureGap : o.dashOffset;
      var gap = o.dashGap < 0 ? o.hachureGap < 0 ? o.strokeWidth * 4 : o.hachureGap : o.dashGap;
      var ops = [];
      lines.forEach(function (line) {
        var length = lineLength(line);
        var count = Math.floor(length / (offset + gap));
        var startOffset = (length + gap - count * (offset + gap)) / 2;
        var p1 = line[0];
        var p2 = line[1];

        if (p1[0] > p2[0]) {
          p1 = line[1];
          p2 = line[0];
        }

        var alpha = Math.atan((p2[1] - p1[1]) / (p2[0] - p1[0]));

        for (var i = 0; i < count; i++) {
          var lstart = i * (offset + gap);
          var lend = lstart + offset;
          var start = [p1[0] + lstart * Math.cos(alpha) + startOffset * Math.cos(alpha), p1[1] + lstart * Math.sin(alpha) + startOffset * Math.sin(alpha)];
          var end = [p1[0] + lend * Math.cos(alpha) + startOffset * Math.cos(alpha), p1[1] + lend * Math.sin(alpha) + startOffset * Math.sin(alpha)];
          ops.push.apply(ops, _toConsumableArray(_this.helper.doubleLineOps(start[0], start[1], end[0], end[1], o)));
        }
      });
      return ops;
    }
  }]);

  return DashedFiller;
}();